var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_16_general_star",
    "data-name": "icons/16/general/star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.294,
    height: 16.21,
    viewBox: "0 0 17.294 16.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_Stroke_",
    "data-name": "Vector (Stroke)",
    d: "M10.474,1.112,12.033,4.18l3.5.494a2.009,2.009,0,0,1,1.125,3.451L14.144,10.5l.592,3.348a2.038,2.038,0,0,1-2.951,2.137l-3.138-1.6-3.137,1.6a2.038,2.038,0,0,1-2.952-2.136L3.149,10.5.635,8.125A2.009,2.009,0,0,1,1.76,4.674l3.5-.494,1.56-3.068A2.056,2.056,0,0,1,10.474,1.112Z",
    transform: "translate(0 0)",
    fill: "#ffd166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStarIcon);
export default __webpack_public_path__ + "static/media/yellow-star-icon.71292956f2fa193aa4813c0dbd3dc7fa.svg";
export { ForwardRef as ReactComponent };